export const landing = {
  hero: {
    titleLine1: 'ითამაშე.',
    titleLine2: 'მოიგე.',
    titleLine3: 'მიიღე.',
    subtitleLine1: 'მიიღე $5 ბონუსი პირველ $5+ შევსებაზე.',
    subtitleLine2: 'ამ ბონუსს შეგიძლია გამოიყენო ტურნირში შესვლის ფასად.',
    signup: 'დარეგისტრირდი ახლავე!',
  },
  platform: {
    title:
      'პლათფორმა<br />სანდო თამაშებით\u00A0— <quick>სწრაფი</quick> ბრძოლებიდან\u00A0<strategy>სტრატეგიულ</strategy> დუელებამდე',
  },
  reasons: {
    title:
      '4 მიზეზი<br /><playing>თამაშის</playing> დასაწყებად <br />პირდაპირ ახლა',
  },
  features: {
    fairCompetitions: {
      title: 'სამართლიანი ტურნირები',
      description:
        'მოთამაშეები ერთმანეთს უნარის მიხედვით ეჯღვნება —<br />მხოლოდ უძლიერესი იგებს!',
    },
    quickMatchStart: {
      title: 'სწრაფი მატჩის დაწყება',
      description: 'იპოვე მოწინააღმდეგე<br />60 წამში და ჩაერთე',
    },
    instantPayouts: {
      title: 'მყისიერი გადახდები',
      description: 'მოგება ერიცხება<br />თამაშის დასრულებისთანავე',
    },
    antiCheatSystem: {
      title: 'ანტი-ჩიტ სისტემა',
      description:
        'ჩვენი ალგორითმები უზრუნველყოფენ სამართლიან თამაშს —<br />ჩიტერებს არ აქვთ შანსი',
    },
  },
  cta: {
    titleMain: 'დარეგისტრირდი და ითამაშე',
    titleAccent: '2 წუთში!',
    bullet1: 'მხოლოდ შენი უნარი განსაზღვრავს შედეგს!',
    bullet2: 'საუკეთესო მოთამაშე იგებს ტურნირს.',
    bullet3: 'მოგებული თანხა ნებისმიერ დროს შეგიძლია გამოიტანო.',
    support: 'კიდევ გაქვს კითხვები?<br />ჩვენ აქ ვართ დასახმარებლად!',
    chatButton: 'დაგვიკავშირდი ჩატში',
    robotAlt: 'რობოტი',
  },
};
